import apiMiddleware from "../../../api/apiMiddleware";

// list inclusions with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `inclusion-master?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create inclusion
const create = async (inclusionData) => {
  const response = await apiMiddleware.post("inclusion-master", inclusionData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// get inclusion by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`inclusion-master/${id}`);
  return response.data;
};

// update inclusion
const update = async ({ id, inclusionData }) => {
  const response = await apiMiddleware.post(
    `inclusion-master/${id}?_method=PUT`,
    inclusionData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// delete inclusion
const deleteInclusion = async (id) => {
  const response = await apiMiddleware.delete(`inclusion-master/${id}`);
  return response.data;
};

// update inclusion order
const updateOrder = async (orderedInclusions) => {
  const response = await apiMiddleware.post(`inclusion-master?_method=PUT`, {
    inclusions: orderedInclusions.map((inclusion, index) => ({
      id: inclusion.id,
      order: index + 1,
    })),
  });
  return response.data;
};

// sort inclusions (same as states)
const sort = async ({ sort_from, sort_to }) => {
  const response = await apiMiddleware.post(`inclusion-master-sort?_method=put`, {
    sort_from,
    sort_to,
  });
  return response.data;
};

export { list, create, getById, update, deleteInclusion, updateOrder, sort };
